const { REACT_APP_PROXY_HOST } = process.env;
const ENDPOINT_COCKPIT_OPERATIONNEL = (REACT_APP_PROXY_HOST || '') + '/monitoring/cockpit/operationnel';
const ENDPOINT_COCKPIT_INCIDENTS = (REACT_APP_PROXY_HOST || '') + '/monitoring/cockpit/incidents';
const SOURCE_SYNCSTATS_DATA_SERVICE = '/syncstatsdataservice-status.json';

export async function chargerCockpitOperationnel(filtres = {}) {
  const params = new URLSearchParams();
  if (filtres.journee) params.set('journee', filtres.journee);

  const query = params.toString();
  const url = query ? `${ENDPOINT_COCKPIT_OPERATIONNEL}?${query}` : ENDPOINT_COCKPIT_OPERATIONNEL;

  // DEBUG navigation
  console.log(`[cockpitOperationnelApi] fetch → ${url} | journee envoyée: ${filtres.journee || '(aucune)'}`);

  const reponse = await fetch(url, { method: 'GET' });
  const texte = await reponse.text();
  if (!reponse.ok) {
    throw new Error(`HTTP ${reponse.status} — ${url}`);
  }
  const payload = JSON.parse(texte);

  // DEBUG navigation
  const incidents = payload.incidentsCritiques || payload.incidents || [];
  const tsMax = incidents.length ? (incidents[0].ts_event || incidents[0].recu_at || 'n/d') : 'n/d';
  const tsMin = incidents.length ? (incidents[incidents.length - 1].ts_event || incidents[incidents.length - 1].recu_at || 'n/d') : 'n/d';
  console.log(`[cockpitOperationnelApi] réponse ← ${incidents.length} incidents | ts_min: ${tsMin} | ts_max: ${tsMax}`);

  return payload;
}

export async function chargerIncidentsOperationnels(filtres = {}) {
  const params = new URLSearchParams();
  if (filtres.camera) params.set('camera', filtres.camera);
  if (filtres.severite && filtres.severite !== 'toutes') params.set('severite', filtres.severite);
  if (filtres.type && filtres.type !== 'tous') params.set('type', filtres.type);

  const query = params.toString();
  const url = query ? `${ENDPOINT_COCKPIT_INCIDENTS}?${query}` : ENDPOINT_COCKPIT_INCIDENTS;
  const reponse = await fetch(url, { method: 'GET' });
  const texte = await reponse.text();
  if (!reponse.ok) {
    throw new Error(`HTTP ${reponse.status} â€” ${url}`);
  }
  const payload = JSON.parse(texte);
  return Array.isArray(payload.incidents) ? payload.incidents : [];
}

export async function chargerSyncStatsDataServiceStatus() {
  try {
    const reponse = await fetch(SOURCE_SYNCSTATS_DATA_SERVICE, { method: 'GET', cache: 'no-store' });
    const texte = await reponse.text();

    if (reponse.status === 404) {
      return normaliserStatusSyncStatsDataService(null, 'projection_absente');
    }
    if (!reponse.ok) {
      return normaliserStatusSyncStatsDataService(null, `projection_indisponible_http_${reponse.status}`);
    }

    try {
      return normaliserStatusSyncStatsDataService(JSON.parse(texte));
    } catch (erreurJson) {
      return normaliserStatusSyncStatsDataService(null, 'json_invalide');
    }
  } catch (erreur) {
    return normaliserStatusSyncStatsDataService(null, 'projection_absente');
  }
}

function normaliserStatusSyncStatsDataService(payload, erreurProjection = '') {
  if (!payload || typeof payload !== 'object' || Array.isArray(payload)) {
    return construireStatusSyncStatsDataServiceVide(erreurProjection);
  }

  const dernierSucces = lirePremierChamp(payload, ['dernierSucces', 'dernier_succes_at', 'lastSuccessAt', 'last_success_at']);
  const dernierCycle = lirePremierChamp(payload, ['dernierCycle', 'dernier_cycle_at', 'lastCycleAt', 'last_cycle_at']);
  const dureeMs = lireNombre(payload, ['dureeMs', 'duree_ms', 'durationMs', 'duration_ms']);
  const retardMs = lireNombre(payload, ['retardMs', 'retard_ms', 'lagMs', 'lag_ms']);
  const seuilRetardMs = lireNombre(payload, ['seuilRetardMs', 'seuil_retard_ms', 'retardSeuilMs', 'retard_seuil_ms']) || 10 * 60 * 1000;
  const etatBrut = String(lirePremierChamp(payload, ['etat', 'statut', 'status', 'state']) || '').trim().toUpperCase();
  const erreurRecente = lirePremierChamp(payload, ['erreurRecente', 'erreur_recente', 'recentError', 'recent_error', 'erreurDerniere', 'erreur_derniere']);
  const logRecent = lirePremierChamp(payload, ['logRecent', 'log_recent', 'recentLog', 'recent_log']);
  const resume = lirePremierChamp(payload, ['resume', 'summary', 'message']) || '';

  const etat = etatBrut || (erreurRecente ? 'ERREUR' : 'INCONNU');
  const niveau = calculerNiveauSyncStatsDataService(etat, dernierSucces, retardMs, seuilRetardMs, erreurRecente);

  return {
    disponible: true,
    etat,
    niveau,
    dernierSucces,
    dernierCycle,
    dureeMs,
    retardMs,
    seuilRetardMs,
    resume,
    erreurRecente,
    logRecent,
    source: SOURCE_SYNCSTATS_DATA_SERVICE,
  };
}

function construireStatusSyncStatsDataServiceVide(erreurProjection) {
  const etat = erreurProjection === 'json_invalide' ? 'ERREUR_PROJECTION' : 'INCONNU';
  return {
    disponible: false,
    etat,
    niveau: 'rouge',
    dernierSucces: '',
    dernierCycle: '',
    dureeMs: null,
    retardMs: null,
    seuilRetardMs: 10 * 60 * 1000,
    resume: erreurProjection === 'json_invalide'
      ? 'Projection JSON invalide.'
      : 'Projection absente.',
    erreurRecente: erreurProjection || '',
    logRecent: '',
    source: SOURCE_SYNCSTATS_DATA_SERVICE,
  };
}

function calculerNiveauSyncStatsDataService(etat, dernierSucces, retardMs, seuilRetardMs, erreurRecente) {
  if (etat.includes('ERREUR') || erreurRecente) return 'rouge';
  if (retardMs !== null && retardMs > seuilRetardMs) return 'orange';

  const ageSuccesMs = ageDepuisMsApi(dernierSucces);
  if (etat.includes('SUCCES') || etat.includes('SUCCESS') || etat.includes('OK')) {
    if (ageSuccesMs === null || ageSuccesMs <= seuilRetardMs) return 'vert';
    return 'orange';
  }

  return 'orange';
}

function lirePremierChamp(objet, champs) {
  for (let i = 0; i < champs.length; i += 1) {
    const valeur = objet[champs[i]];
    if (valeur !== undefined && valeur !== null && valeur !== '') return valeur;
  }
  return '';
}

function lireNombre(objet, champs) {
  const valeur = lirePremierChamp(objet, champs);
  if (valeur === '') return null;
  const nombre = Number(valeur);
  return Number.isFinite(nombre) ? nombre : null;
}

function ageDepuisMsApi(ts) {
  if (!ts) return null;
  const d = new Date(ts);
  if (Number.isNaN(d.getTime())) return null;
  return Math.max(0, Date.now() - d.getTime());
}



// WEBPACK FOOTER //
// src/components/cockpit/cockpitOperationnelApi.js